import {Navigate} from '@tanstack/react-router';
import {useAuth} from '@workos-inc/authkit-react';
import React from 'react';
import {authLogger} from '@/features/auth/services/logger';

function ProtectedRoute({children}: React.PropsWithChildren) {
  const {user, isLoading} = useAuth();

  if (isLoading) {
    authLogger.debug('Loading auth state');
    return null;
  }

  if (!user) {
    authLogger.debug('Redirecting to /auth/login');
    return <Navigate to="/auth/login" search={{returnTo: globalThis.location.pathname}} />;
  }

  return children;
}

export {ProtectedRoute};
